import styled from 'styled-components';
import { getTheme } from '../../theme';

const Card = styled.div`
  background-color: ${props => getTheme(props.theme?.isDark).colors.surfaceElevated};
  border: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
  border-radius: ${props => getTheme(props.theme?.isDark).borderRadius.lg};
  padding: ${props => getTheme(props.theme?.isDark).spacing.lg};
  box-shadow: ${props => getTheme(props.theme?.isDark).shadows.md};
  ${props => props.theme?.isDark && `
    box-shadow: 0 4px 6px rgba(0, 255, 0, 0.1);
  `}
`;

export default Card;


